import { useState } from 'react';

// Hooks
import useEffectOnce from "@utility/hooks/useEffectOnce";
import useParameterUrl from "@utility/hooks/useParameterUrl";
// import useOnlineStatus from "@utility/hooks/useOnlineStatus";

// Auth & JWT
import { isTokenGeneral, isUserLoggedIn } from "@core/auth/utils";
import { checkExpireTokenGeneral, loadTokenGeneral } from "@core/auth/jwt/jwtService";

// Component
import Layouts from "views/Layouts";
import ConfirmWarning from "views/components/ConfirmWarning";
import ErrorApp from "views/components/Error/index";

// Style & CSS
import './App.css';
import "assets/css/Style.css";
import "assets/css/Button.css";
import "assets/css/Animation.css";

function App() {
  const [loadRoutes, setLoadRoutes] = useState(false);
  const [statusLayout, setStatusLayout] = useState(null);
  const [textData, setTextData] = useState(false);
  const [dataSettingError, setDataSettingError] = useState(null);

  // OFFLINE: ตัดการใช้งาน offline ออก
  // const [dataSettingOffline, setDataSettingOffline] = useState(null);

  const parsed = useParameterUrl();
  const { msg } = parsed;

  const domain = window.location.host;
  const agent_code = process.env.REACT_APP_DEFAULT_AGENT_CODE;

  // const isOnline = useOnlineStatus();
  // const [errorMode, setErrorMode] = useState("");
  // const errorMode = "";

  // ป้องกันการพังของ service ที่เคยรับ setDataSettingOffline โดยส่ง noop ไปแทน
  const noop = () => { };

  const setTokenGeneral = () => {
    let myJson = { domain };
    if (agent_code !== "" && agent_code !== undefined) {
      myJson = {
        agent_code: agent_code,
        agent_hash: agent_code
      };
    }

    // เดิม: loadTokenGeneral(myJson, setLoadRoutes, setDataSettingError, setDataSettingOffline);
    // OFFLINE: ตัด offline -> ส่ง noop แทน
    loadTokenGeneral(myJson, setLoadRoutes, setDataSettingError, noop);
  };

  const renderContent = () => {
    // OFFLINE UI ถูกตัดออก
    // if (!isOnline || errorMode === "permission") {
    //   return <ErrorApp typeError="offline"></ErrorApp>;
    // }

    if (statusLayout !== null) {
      if (statusLayout) {
        // เดิม: if (!dataSettingError && !dataSettingOffline)
        if (!dataSettingError) {
          if (loadRoutes === true) {
            return <Layouts loadRoutes={loadRoutes} domain={domain} />;
          }
          return null;
        }

        // OFFLINE: ไม่แสดงหน้า offline อีกต่อไป
        // if (dataSettingOffline) {
        //   return <ErrorApp typeError="offline"></ErrorApp>;
        // }

        if (dataSettingError) {
          return <ErrorApp typeError="noData"></ErrorApp>;
        }

        return null;
      }

      return <ConfirmWarning text={textData} close={true} />;
    }

    return null;
  };

  useEffectOnce(() => {
    try {
      if (msg !== null && msg !== undefined && msg !== "undefined" && msg !== "") {
        setTextData(msg);
        setStatusLayout(false);
      } else {
        setStatusLayout(true);

        const renderToken = () => {
          if (isUserLoggedIn()) {
            setLoadRoutes(true);
            setDataSettingError(false);
            // OFFLINE: setDataSettingOffline(false);
          } else {
            if (isTokenGeneral()) {
              if (checkExpireTokenGeneral()) {
                setTokenGeneral();
              } else {
                setDataSettingError(false);
                // OFFLINE: setDataSettingOffline(false);
                setLoadRoutes(true);
              }
            } else {
              setTokenGeneral();
            }
          }
        };

        renderToken();
      }
    } catch (error) {
      // OFFLINE: เดิม setDataSettingOffline(true)
      setDataSettingError(true);
    }
  }, []);

  // useEffect(() => {
  //   navigator.serviceWorker.addEventListener('message', (event) => {
  //     if (event.data.type === 'errorMode') {
  //       const errorMode = event?.data?.isErrorMode;
  //       setErrorMode((errorMode === undefined || errorMode === null) ? "" : errorMode);
  //     }
  //   });
  // }, []);

  return renderContent();
}

export default App;
